module.exports = global["application_survey_sociodemographique"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./sociodemographique.ts");